module.exports = __webpack_public_path__ + "img/zbbs.f9efd8a.png";